import { AttachmentType } from "projectDesign/components/projectConfiguration/fields/attachmentType";

export function getSMTiltProjectConfigurationData(projectEnvConfig: any) {
  const {
    zipcode,
    building_code,
    building_height,
    wind_speed,
    snow_load,
    elevation,
    wind_exposure,
    rail_finish,
    roof_type,  
    preferred_span,
    tilt,
    rafter_spacing_inches,
    env_factors_for,
    client_address,
    client_name,
    created_user_time,
    building_type,
    shortest_building_length,
    pro_clamps,
    risk_category,
    clamps_choices,
    mid_clamps_choices,
    end_clamps_choices,
    adjustable_tilt_system,
    topographical_factor_kzt,
    seismic_ss,
    attachment_type,
    domestic_content,
  } = projectEnvConfig;

  return {
    zipcode,
    building_code,
    building_height,
    wind_speed,
    snow_load,
    elevation,
    wind_exposure,
    rail_finish,
    roof_type,  
    preferred_span,
    tilt,
    rafter_spacing_inches,
    env_factors_for,
    client_address,
    client_name,
    created_user_time,
    building_type,
    shortest_building_length,
    pro_clamps: pro_clamps ? 1 : 0,
    mid_clamps_choices,
    end_clamps_choices,
    risk_category,
    clamps_choices: clamps_choices? clamps_choices:(pro_clamps? 1: 2),
    adjustable_tilt_system :  adjustable_tilt_system ? adjustable_tilt_system : 9 ,
    topographical_factor_kzt,
    seismic_ss,
    attachment_type: attachment_type || AttachmentType.L_FOOT_ONLY,
    domestic_content,
  };
}
